<div id="myReferrals" class='main-container' data-cy="referrer-portal-home-container">
  @if (isLoading) {
    <mat-progress-spinner
      class="loading-spinner"
    diameter="100" mode="indeterminate" data-cy="referrer-portal-loading-spinner"></mat-progress-spinner>
  }

  @if (referralsInfo && !isLoading) {
    <div class="referrals-grid" [class.mobile]="isHandsetOrTablet" data-cy="referrer-portal-grid">
      <div class="referrals-list-container" [class.mobile]="isHandsetOrTablet" data-cy="referrer-portal-referrals-tile">
        <mat-card appearance="outlined" class="referrals-card" data-cy="referrer-portal-referrals-card">
          <div class="title-search-row" [class.mobile]="isHandsetOrTablet">
            <span class="configuration-section-title" data-cy="referrer-portal-title">My Referrals</span>
            <app-tdo-search #search class="search-input" [class.mobile]="isHandsetOrTablet"
            (searchChange)="applySearchFilter($event)" placeholder="Search" data-cy="referrer-portal-search-input"></app-tdo-search>
          </div>
          <div class="referrals-content" data-cy="referrer-portal-content">
            <div class="date-range-filters" [class.mobile]="isHandsetOrTablet">
              <div class="date-range-container" [class.mobile]="isHandsetOrTablet" data-cy="referrer-portal-daterange-container">
                <div class="date-range-label" data-cy="referrer-portal-daterange-label">Referral Date Range:</div>
                <div class="date-input-wrapper" data-cy="referrer-portal-startdate-container">
                  <input class="date-input" matInput (dateChange)="onSearchDateChange($event)" [(ngModel)]="datePickerStart"
                    [matDatepicker]="pickerStart"  [min]="minSearchDate" [max]="maxSearchDate"
                    placeholder="Start Date" data-cy="referrer-portal-startdate-input">
                    <mat-datepicker-toggle matSuffix [for]="pickerStart" class="date-toggle" data-cy="referrer-portal-startdate-toggle"></mat-datepicker-toggle>
                    <mat-datepicker #pickerStart data-cy="referrer-portal-startdate-picker"></mat-datepicker>
                  </div>
                  <div class="date-input-wrapper" data-cy="referrer-portal-enddate-container">
                    <input class="date-input" matInput (dateChange)="onSearchDateChange($event)" [(ngModel)]="datePickerEnd"
                      [matDatepicker]="pickerEnd"  [min]="minSearchDate" [max]="maxSearchDate"
                      placeholder="End Date" data-cy="referrer-portal-enddate-input">
                      <mat-datepicker-toggle matSuffix [for]="pickerEnd" class="date-toggle" data-cy="referrer-portal-enddate-toggle"></mat-datepicker-toggle>
                      <mat-datepicker #pickerEnd data-cy="referrer-portal-enddate-picker"></mat-datepicker>
                    </div>
                  </div>
                </div>
                @if (referralsInfo && !isLoading) {
                  <tdo-table #referralsTable [dataSource]="referralsInfo" class="referrals-table"
                    [isUsePaginator]="true" [searchPredicate]="searchPredicate" (rowSelected)="onRowSelected($event)" isSearchable="false"
                    [isAutoSelectFirstItem]="autoSelectFirstReferral" noDataMessage="Referrals not found for the specified information." cypressControlIdentifier="tdo-referrals" data-cy="referrer-portal-referrals-table">
                    <tdo-table-column displayName="Patient" propertyName="Patient_FirstName" isSortable="true" [rowTemplate]="patientname" data-cy="referrer-portal-column-patient">
                      <ng-template #patientname let-row>
                        <div data-cy="referrer-portal-patient-name">{{row.model.Patient_FirstName}} {{row.model.Patient_LastName}}</div>
                      </ng-template>
                    </tdo-table-column>
                    <tdo-table-column displayName="DOB" isSortable="true" propertyName="Patient_DOB" [rowTemplate]="dob" dataType="datetime" data-cy="referrer-portal-column-dob">
                      <ng-template #dob let-row>
                        @if (row.model.Patient_DOB) {
                          <div data-cy="referrer-portal-patient-dob">{{ row.model.Patient_DOB | date: 'shortDate'}}</div>
                        }
                      </ng-template>
                    </tdo-table-column>
                    <tdo-table-column displayName="Communication" isSortable="true" propertyName="Patient_Phone" [rowTemplate]="patientphone" data-cy="referrer-portal-column-phone">
                      <ng-template #patientphone let-row>
                        @if (row.model.Patient_Phone) {
                          <div data-cy="referrer-portal-patient-phone"><a href="tel:{{ row.model.Patient_Phone }}" (click)="$event.stopPropagation()">{{ row.model.Patient_Phone | formatPhoneNumber }}</a></div>
                        }
                        @if (row.model.Patient_Email) {
                          <div data-cy="referrer-portal-patient-email"><a href="mailto:{{ row.model.Patient_Email }}" (click)="$event.stopPropagation()">{{ row.model.Patient_Email }}</a></div>
                        }
                      </ng-template>
                    </tdo-table-column>
                    <tdo-table-column displayName="Last Referral" isSortable="true" propertyName="xauditCreatedOn" [rowTemplate]="lstreferral" dataType="datetime" data-cy="referrer-portal-column-last-referral">
                      <ng-template #lstreferral let-row>
                        @if (row.model.xauditCreatedOn) {
                          <div data-cy="referrer-portal-referral-creation">{{ getDate(row.model.xauditCreatedOn) | date:'shortDate' }}</div>
                        }
                      </ng-template>
                    </tdo-table-column>
                    <tdo-table-column displayName="Doctor" targetObjectName="DataReferralDoctor.FullName" propertyName="Doctor" isSortable="true" [rowTemplate]="doctor" data-cy="referrer-portal-column-doctor">
                      <ng-template #doctor let-row>
                        @if (row.model.DataReferralDoctor) {
                          <div data-cy="referrer-portal-referral-doctor">{{ row.model.DataReferralDoctor.FullName }}</div>
                        }
                      </ng-template>
                    </tdo-table-column>
                    <tdo-table-column displayName="Appointment" isSortable="true" propertyName="Appointment" [rowTemplate]="appt" data-cy="referrer-portal-column-appointment">
                      <ng-template #appt let-row>
                        @if (row.model.Appointment) {
                          <div data-cy="referrer-portal-referral-appointment">{{ row.model.Appointment.StartDate | date:'shortDate' }}</div>
                        }
                      </ng-template>
                    </tdo-table-column>
                    <tdo-table-column displayName="Status" propertyName="StatusName" isSortable="true" [rowTemplate]="status" data-cy="referrer-portal-column-status">
                      <ng-template #status let-row>
                        @if (row.model.StatusName) {
                          <div data-cy="referrer-portal-referral-status">{{ row.model.StatusName }}</div>
                        }
                      </ng-template>
                    </tdo-table-column>
                  </tdo-table>
                }
              </div>
            </mat-card>
          </div>
          @if (!isHandsetOrTablet || selectedReferral) {
            <div class="referral-detail-container" [class.mobile]="isHandsetOrTablet" data-cy="referrer-portal-detail-tile">
              <mat-card appearance="outlined" class="detail-card" data-cy="referrer-portal-detail-card">
                @if (isHandsetOrTablet) {
                  <mat-card-header>
                    <button mat-icon-button class="close-button" (click)="closeDetailView()" data-cy="referrer-portal-close-button">
                      <lucide-icon name="x" [size]="20"></lucide-icon>
                    </button>
                  </mat-card-header>
                }
                <mat-card-content class="detail-content" data-cy="referrer-portal-detail-content">
                  <app-referrer-portal-referral-detail [referral]="selectedReferral" [targetDocumentId]="deepLinkDocumentId" class="detail-component" data-cy="referrer-portal-referral-detail"></app-referrer-portal-referral-detail>
                </mat-card-content>
              </mat-card>
            </div>
          }
        </div>
      }

    </div>
